module.exports = __webpack_public_path__ + "img/59.4dd2dc16.jpg";